module.exports = __webpack_public_path__ + "img/embedded_type.b52e919e.png";